import React from 'react';
import MassFinalizeItem from '../../../Domain/MassFinalizeItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';

export default class BulkFinalizeClientInvoiceDescription extends React.Component {
  static titleForEdit = 'Invoice Bulk Finalization';
  static finishButtonLabel = 'Finalize';
  static itemType = MassFinalizeItem;
  static serviceFunction = ClientInvoiceService.BulkFinalizeInvoice;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'IdListString',
          label: 'Invoice IDs (id1,id2,id3...)',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];
}
